import { execSync } from "node:child_process";

/**
 * Returns the current full git branch name
 *
 * ie: feature/1234 returns feature/1234
 *
 */
export const findGitBranch = (): string => {
  return execSync("git rev-parse --abbrev-ref HEAD")
    .toString("utf8")
    .replace(/[\n\r\s]+$/, "");
};

export const findGitRepoName = (): string => {
  /**
   * When running in github actions this will be populated.
   */
  if (process.env.GITHUB_REPOSITORY) {
    return process.env.GITHUB_REPOSITORY;
  }

  /**
   * locally, we need to extract the repo name from the git config.
   */
  const remote = execSync("git config --get remote.origin.url")
    .toString("utf8")
    .replace(/[\n\r\s]+$/, "")
    .trim();

  const match = remote.match(/[:\/]([^/]+\/[^/]+?)(?:\.git)?$/);
  const repoName = match ? match[1] : "error-repo-name";

  return repoName;
};
